import { BASE_ALOFT_URL } from 'constants/envVars';
import { addAlert } from 'actions/alerts';
import { createErrorAlert } from 'utils/generalUtils';
import axiosInstance from 'services/axiosConfig';

export const fetchNotice = () => async (dispatch, getState) => {
	try {
		const url = `${BASE_ALOFT_URL}/v1/notices`;
		const response = await axiosInstance.get(url);
		return response.data.data;
	} catch (error) {
		const { errors } = error.response.data;
		for (const error in errors) {
			const alert = createErrorAlert({ error: errors[error][0], message: errors[error][0] });
			dispatch(addAlert(alert));
			console.error(errors[error][0]);
		}
		return errors;
	}
};
